export default __webpack_public_path__ + "static/media/formAddField.70487e21.png";